angular.module('app')
    .controller('VariazioneTargatoCtrl', function ($scope) {
        
        $scope.initialize = function () {

        }

        $scope.start = function () {

        }

        $scope.onPressSearch = function (value) {
            $scope.filter = value
        }

        $scope.getDropdownsForContracts = function () {

        }


      

    })